// extracted by mini-css-extract-plugin
export var deliveryRow = "_o6-a";
export var fixedHeight = "_o6-4";
export var freightLogo = "_o6-9";
export var fullWidth = "_o6-3";
export var priceColumn = "_o6-5";
export var radioSelected = "_o6-7";
export var radioUnselected = "_o6-6";
export var selectedOption = "_o6-2";
export var selectedOptionContainer = "_o6-1";
export var selection = "_o6-0";
export var tallSkeletonText = "_o6-8";